import { render } from "./BMI.vue?vue&type=template&id=2f6908a3&scoped=true"
import script from "./BMI.vue?vue&type=script&lang=js"
export * from "./BMI.vue?vue&type=script&lang=js"

import "./BMI.vue?vue&type=style&index=0&id=2f6908a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6908a3"]])

export default __exports__